export default __webpack_public_path__ + "static/media/freelancer.35c6b176.svg";